module.exports = __webpack_public_path__ + "static/img/__8934.52d4be6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__8934.jpg
// module id = y5vq
// module chunks = 0